export type AdminNotificationEventType =
  | 'new_user'
  | 'newsletter_subscription'
  | 'new_subscription'
  | 'trial_activation'
  | 'custom_plan_request'
  | string

export interface AdminNotification {
  id: string
  event_type: AdminNotificationEventType
  title: string
  message: string
  metadata: Record<string, any>
  created_at: string
  is_read?: boolean
}

export interface AdminNotificationRead {
  id: string
  notification_id: string
  admin_id: string
  read_at: string
}

export interface EventTypeConfig {
  icon: string
  color: string
  bgColor: string
  label: string
  href?: string
}

export const EVENT_TYPE_CONFIG: Record<string, EventTypeConfig> = {
  new_user: {
    icon: 'UserPlus',
    color: 'text-moss-700 dark:text-moss-300',
    bgColor: 'bg-moss-100 dark:bg-moss-500/20',
    label: 'Novo Usuário',
  },
  newsletter_subscription: {
    icon: 'Mail',
    color: 'text-ink-500 dark:text-cream-300',
    bgColor: 'bg-cream-200 dark:bg-ink-500/40',
    label: 'Newsletter',
  },
  new_subscription: {
    icon: 'CreditCard',
    color: 'text-terra-700 dark:text-terra-300',
    bgColor: 'bg-terra-100 dark:bg-terra-500/20',
    label: 'Assinatura',
  },
  trial_activation: {
    icon: 'Clock',
    color: 'text-ochre-700 dark:text-ochre-300',
    bgColor: 'bg-ochre-100 dark:bg-ochre-500/20',
    label: 'Trial',
  },
  admin_message: {
    icon: 'MessageSquare',
    color: 'text-blood-700 dark:text-blood-300',
    bgColor: 'bg-blood-100 dark:bg-blood-500/20',
    label: 'Admin',
  },
  custom_plan_request: {
    icon: 'Handshake',
    color: 'text-terra-700 dark:text-terra-300',
    bgColor: 'bg-terra-100 dark:bg-terra-500/20',
    label: 'Plano personalizado',
    href: '/admin/planos-personalizados',
  },
}

export const DEFAULT_EVENT_CONFIG: EventTypeConfig = {
  icon: 'Bell',
  color: 'text-ink-500 dark:text-cream-300',
  bgColor: 'bg-cream-200 dark:bg-ink-500/40',
  label: 'Evento',
}

export function getEventConfig(eventType: string): EventTypeConfig {
  return EVENT_TYPE_CONFIG[eventType] || DEFAULT_EVENT_CONFIG
}
